import './dashboardScreen.scss'
import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import CardComponent from "../../shared/components/card/cardComponent";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import commonService from "../../shared/services/common.service";
import {useNavigate} from "react-router-dom";
import {IRootReducerState} from "../../store/reducers";
import LottieFileGenarationComponent
    from "../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../constants";
import StatusCardComponent from "../../shared/components/status-card/statusCardComponent";

interface DashboardScreenProps {

}

const DashboardScreen = (props: DashboardScreenProps) => {
        const dispatch = useDispatch();
        const navigate = useNavigate();

        const [dashBoardModulesData, setDashBoardModulesData] = useState<any>([]);
        const [dashBoardModulesDataLoading, setDashBoardModulesDataLoading] = useState<boolean>(false);
        const [dashBoardModulesDataLoadingFailed, setDashBoardModulesDataLoadingFailed] = useState<boolean>(false);
        const [dashBoardModulesDataLoaded, setDashBoardModulesDataLoaded] = useState<boolean>(false);


        const getDashboardModulesData = useCallback(() => {
            const payload = {};
            setDashBoardModulesDataLoaded(false);
            setDashBoardModulesDataLoading(true);
            setDashBoardModulesDataLoadingFailed(false);

            commonService._dashboard.getDashboardModulesData(payload)
                .then((res) => {
                    setDashBoardModulesData(res.data);
                    setDashBoardModulesDataLoaded(true);
                    setDashBoardModulesDataLoading(false);
                    setDashBoardModulesDataLoadingFailed(false);

                })
                .catch((err: any) => {
                    setDashBoardModulesDataLoading(false);
                    setDashBoardModulesDataLoadingFailed(true);
                    setDashBoardModulesDataLoaded(false);
                })
        }, []);

        const navigateModuleRedirectionUrl = (module: string) => {
            switch (module) {
                case 'facility':
                    navigate(commonService._routeConfig.FacilityListRoute());
                    return;
                case 'Location':
                    navigate(commonService._routeConfig.LocationListRoute());
                    return;
                case 'testOrder':
                    navigate(commonService._routeConfig.TestOrderListRoute());
                    return
                case 'patient':
                    navigate(commonService._routeConfig.PatientListRoute());
                    return;
                default:
                    navigate(commonService._routeConfig.DashboardRoute());
                    return;
            }
        }

        useEffect(() => {
            dispatch(setCurrentNavParams("Dashboard", "Dashboard"));
            dispatch(setSideMenuView('default'));
        }, [dispatch]);

        useEffect(() => {
            getDashboardModulesData();
        }, [getDashboardModulesData]);

        const {currentUser} = useSelector((state: IRootReducerState) => state.account);

        return (
            <div className="dashboard-screen screen">
                <div className={'dashboard-user-name-wrapper'}>
                    Welcome {commonService.capitalizeFirstLetterOfEachWord((currentUser?.firstName ? (currentUser?.firstName + ' ') : '') + (currentUser?.middleName ? (currentUser?.middleName + ' ') : '') + (currentUser?.lastName ? (currentUser?.lastName + ' ') : ''))} !
                </div>
                {
                    dashBoardModulesDataLoading && <div className="h-v-center">
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                {
                    dashBoardModulesDataLoadingFailed && <>
                        <StatusCardComponent title={"Dashboard details failed to load"}/>
                    </>
                }
                {
                    dashBoardModulesDataLoaded && <>

                        <div className={'dashboard-body-wrapper'}>
                            <div className={'dashBoard-modules-wrapper'}>
                                {
                                    dashBoardModulesData?.onBoarding?.map((module: any, index: any) => {
                                        return (
                                            <CardComponent className={'dashboard-module-card-component'} key={index}>
                                                <div className={'dashboard-module-title'}>
                                                    {commonService.capitalizeFirstLetterOfEachWord(module.title)}
                                                </div>
                                                <div className={'dashboard-module-count'}>
                                                    {module.count}
                                                </div>
                                                <div className={'dashboard-module-view-button'}>
                                                    <ButtonComponent
                                                        color={"primary"}
                                                        type={"button"}
                                                        className={'dashboard-module-view-button-component'}
                                                        variant={"contained"}
                                                        handleClick={() => {
                                                            navigateModuleRedirectionUrl(module?.code);
                                                        }}
                                                        fullWidth={false}
                                                    >
                                                        View
                                                    </ButtonComponent>
                                                </div>
                                            </CardComponent>
                                        )
                                    })
                                }

                            </div>
                            <div className={'dashBoard-samples-wrapper'}>
                                {
                                    dashBoardModulesData?.orderUpdate?.map((module: any, index: any) => {
                                        return (
                                            <CardComponent className={'dashboard-sample-card-component'} key={index}>
                                                <div className={'dashboard-sample-title'}>
                                                    {commonService.capitalizeFirstLetterOfEachWord(module?.title)}
                                                </div>
                                                <div className={'dashboard-sample-count'}>
                                                    {module?.count}
                                                </div>
                                                <div className={'dashboard-sample-view-button'}>
                                                    <ButtonComponent
                                                        color={"primary"}
                                                        type={"button"}
                                                        className={'dashboard-sample-view-button-component'}
                                                        variant={"contained"}
                                                        handleClick={() => {
                                                            navigate(commonService._routeConfig.sampleListRouteWithQueryParams( module?.status));
                                                        }}
                                                        fullWidth={false}
                                                    >
                                                        View
                                                    </ButtonComponent>
                                                </div>
                                            </CardComponent>
                                        )
                                    })
                                }

                            </div>
                        </div>
                    </>
                }
                {/*<div className="screen-content-wrapper height-vh-80">*/}
                {/*    <ComingSoonScreen featureName={'Dashboard'}/>*/}
                {/*</div>*/}
            </div>
        )

    }

;

export default DashboardScreen;
